"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var base_map_directive_1 = require('./base-map-directive');
var ng2_map_component_1 = require('../components/ng2-map.component');
var INPUTS = [
    'clickable', 'draggable', 'editable', 'geodesic', 'icons', 'path', 'strokeColor',
    'strokeOpacity', 'strokeWeight', 'visible', 'zIndex', 'options'
];
var OUTPUTS = [
    'click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown',
    'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'
];
var Polyline = (function (_super) {
    __extends(Polyline, _super);
    function Polyline(ng2MapComp) {
        _super.call(this, ng2MapComp, 'Polyline', INPUTS, OUTPUTS);
        this.initialized$ = new core_1.EventEmitter();
    }
    Polyline.decorators = [
        { type: core_1.Directive, args: [{
                    selector: 'ng2-map > polyline',
                    inputs: INPUTS,
                    outputs: OUTPUTS,
                },] },
    ];
    /** @nocollapse */
    Polyline.ctorParameters = [
        { type: ng2_map_component_1.Ng2MapComponent, },
    ];
    Polyline.propDecorators = {
        'initialized$': [{ type: core_1.Output },],
    };
    return Polyline;
}(base_map_directive_1.BaseMapDirective));
exports.Polyline = Polyline;
//# sourceMappingURL=polyline.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-map/dist/directives/polyline.js
// module id = 38
// module chunks = 0